var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackblitz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.412h4.591L4.891 16l8.776-9.412H9.076L11.776 0 3 9.412z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMyA5LjQxMTU2SDcuNTkxMTFMNC44OTA2NyAxNkwxMy42NjY3IDYuNTg4NDRIOS4wNzU1NUwxMS43NzYgMEwzIDkuNDExNTZaIgogICAgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4=";
export { SvgStackblitz as ReactComponent };